import axios from 'axios';
import env from 'variables/config';
import { errorHandler } from './utils';

axios.defaults.baseURL = env.apiUrl;

const config = () => {
    return {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    };
};

export const getProductForecast = async (productId: string, period: 'week' | 'month') => {
    try {
        const res = await axios.get(
            `/forecasting/${productId}?period=${period}`,
            config()
        );
        return res.data;
    } catch (err) {
        errorHandler(err);
        return null;
    }
};
export const getTopProductsForecast = async (period: 'week' | 'month') => {
    try {
        const res = await axios.get(
            `/forecasting/top?period=${period}`,
            config()
        );
        return res.data;
    } catch (error) {
        errorHandler(error);
        return [];
    }
};